/** The trigger which caused the save action. */
export enum BarEditPageSaveReason {
    /** The save happened because the user clicked on the save button. */
    Default,
    /** The save happened because of an autosave. */
    Autosave,
    /** Custom reason (save function invoked). */
    Custom
}
